export class CampanhaEncarteArquivo {
    id: string;
    cmaArquivo: string;
   // base64CSV: string;
   // base64Zip: string
}
